export const typesSojourn = {
    GET_SOJOURN_SUCCESS:'GET_SOJOURN_SUCCESS',
    GET_SOJOURN_ERROR:'GET_SOJOURN_ERROR',
    GET_SOJOURN_BEGIN:'GET_SOJOURN_BEGIN'
}
